import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router"

export const Route = createFileRoute("/_authenticated/$slug/settings/integrations")({
  staticData: { title: "Integrations" },
  component: lazyRouteComponent(
    () => import("#pages/authenticated/settings/integrations.tsx"),
    "IntegrationsSettings",
  ),
})
